export default "__VITE_ASSET__KFB2qCxE__"